import classnames from 'classnames';
import React from 'react';
import { Checkbox } from 'sonata-react-components';

import './card.scss';

type Props = {
  active: boolean;
  id: string;
  isDisabled?: boolean;
  onChange: (id: string) => void;
  price: string;
  subtitle: string;
  title: string;
};

const Card: React.VFC<Props> = ({ active, id, isDisabled = false, onChange, price, subtitle, title }) => {
  const handleClick = () => {
    if (!isDisabled) {
      onChange(id);
    }
  };

  return (
    <div
      className={classnames('planCard', {
        'planCard--isActive': active,
        'planCard--isDisabled': isDisabled
      })}
      data-testid="card"
      id={id}
      onClick={handleClick}
    >
      <div className="planCard__topSection">
        <Checkbox active={active} disabled={isDisabled} id={`card-${id}`} type="radio" />
        <i className="fa-regular fa-bolt planCard__icon" />
        <div>
          <div className="planCard__title">{title}</div>
          <div className="planCard__subtitle">{subtitle}</div>
        </div>
      </div>
      <div className="planCard__bottomSection">{price}</div>
    </div>
  );
};

export default Card;
